import { render, staticRenderFns } from "./SelectDepot.vue?vue&type=template&id=03fefdf5"
import script from "./SelectDepot.vue?vue&type=script&lang=js"
export * from "./SelectDepot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports